import React, { useState, useEffect } from "react";
import AdminSidebar from "../../component/AdminComp/AdminSidebar";
import AdminTopbar from "../../component/AdminComp/AdminTopbar";
import { Filter, Download } from "react-feather";
import { Dropdown } from "react-bootstrap";
import * as XLSX from "xlsx";
import axios from "axios";
import { baseurl } from "../../Baseurl";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const RejectedListing = () => {
  const [listings, setListings] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPendingListings = async () => {
      try {
        const response = await axios.get(`${baseurl}getAllRejectedListings`);
        if (response.data.success) {
          setListings(response.data.data);
          setFilteredData(response.data.data);
        }
      } catch (error) {
        console.error("❌ Error fetching listings:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchPendingListings();
  }, []);

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "This listing will be permanently deleted!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (!result.isConfirmed) return;

    try {
      const response = await axios.post(`${baseurl}deleteSellerListingAdmin`, { id });

      if (response.data.success) {
        const updated = listings.filter((item) => item.id !== id);
        setListings(updated);
        setFilteredData(updated);

        Swal.fire({
          icon: "success",
          title: "Deleted!",
          text: "Listing deleted successfully.",
          timer: 2000,
          showConfirmButton: false,
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed!",
          text: "Failed to delete listing.",
        });
      }
    } catch (error) {
      console.error("❌ Error deleting listing:", error);
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "Something went wrong while deleting.",
      });
    }
  };

  const handleDownloadExcel = () => {
    const ws = XLSX.utils.json_to_sheet(filteredData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Rejected Seller Listings");
    XLSX.writeFile(wb, "rejected_seller_listings.xlsx");
  };

  return (
    <div className="App" style={{ display: "flex" }}>
      <AdminSidebar />
      <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
        <AdminTopbar />
        <div className="container-fluid">
          {/* Header and Controls */}
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h4>Rejected Seller Listings</h4>
            <div className="d-flex align-items-center">
              <input
                type="text"
                className="form-control me-2"
                placeholder="Search Listings"
                onChange={(e) =>
                  setFilteredData(
                    listings.filter((listing) =>
                      listing.title
                        .toLowerCase()
                        .includes(e.target.value.toLowerCase())
                    )
                  )
                }
              />
              <Dropdown className="me-2">
                <Dropdown.Toggle className="form-control prwcl" id="dropdown-basic">
                  <Filter size={16} /> Status Filter
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => setFilteredData(listings)}>
                    All
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>

              <button className="btn btnsuccess" onClick={handleDownloadExcel}>
                <Download size={17} /> Download
              </button>
            </div>
          </div>

          {/* Table Section */}
          <div className="card">
            <div className="card-body p-0">
              {loading ? (
                <div className="p-3">
                  {/* Skeleton Header */}
                  <Skeleton height={35} width="30%" style={{ marginBottom: "15px" }} />

                  {/* Skeleton Table */}
                  <table className="custom-table w-100">
                    <thead>
                      <tr>
                        {Array(5)
                          .fill()
                          .map((_, i) => (
                            <th key={i}>
                              <Skeleton height={20} />
                            </th>
                          ))}
                      </tr>
                    </thead>
                    <tbody>
                      {Array(6)
                        .fill()
                        .map((_, rowIdx) => (
                          <tr key={rowIdx}>
                            {Array(5)
                              .fill()
                              .map((__, colIdx) => (
                                <td key={colIdx}>
                                  <Skeleton height={20} />
                                </td>
                              ))}
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div style={{ overflowX: "auto", maxHeight: "500px" }}>
                  <table className="custom-table mb-0">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Title</th>
                        <th>Condition</th>
                        <th>Created At</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredData.map((row) => (
                        <tr key={row.id}>
                          <td>{row.id}</td>
                          <td>{row.title}</td>
                          <td>{row.condition}</td>
                          <td>{new Date(row.created_at).toLocaleString()}</td>
                          <td>
                            <div className="d-flex gap-2">
                              <Link
                                to={`/admin/seller-listing-details/${row.id}`}
                                className="btn btn-primary btn-sm me-2"
                              >
                                View Details
                              </Link>
                              <button
                                className="btn btn-danger btn-sm"
                                onClick={() => handleDelete(row.id)}
                              >
                                Delete
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                      {filteredData.length === 0 && (
                        <tr>
                          <td colSpan="5" className="text-center py-3">
                            No data found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RejectedListing;
